export const ENVS = {
  DEVELOPMENT: 'development',
  PRODUCTION: 'production',
} as const;

export type Env = (typeof ENVS)[keyof typeof ENVS];

export const MANAGE_HOSTNAMES = {
  [ENVS.DEVELOPMENT]: 'manage-dev.matto.com',
  [ENVS.PRODUCTION]: 'manage.matto.com',
};

function getEnvFromCurrentHostname(): Env {
  const hostname = window.location.hostname;

  if (hostname === MANAGE_HOSTNAMES[ENVS.DEVELOPMENT]) {
    return ENVS.DEVELOPMENT;
  }

  if (hostname === MANAGE_HOSTNAMES[ENVS.PRODUCTION]) {
    return ENVS.PRODUCTION;
  }

  return ENVS.DEVELOPMENT;
}

export function getEnv() {
  return getEnvFromCurrentHostname();
}
